const NAVBAR_HIDDEN_ROUTES = new Set([
  "/login",
  "/register",
  "/verify-email",
  "/forgot",
  "/business/register",
  "/business/login",
  "/checkout/result",
]);

const NAVBAR_HIDDEN_PREFIXES = ["/business", "/supplier", "/admin"];
const FOOTER_HIDDEN_ROUTES = new Set(["/checkout/result"]);
const FOOTER_HIDDEN_PREFIXES = ["/messages"];
const CART_ACTION_HIDDEN_ROUTES = new Set(["/cart", "/checkout", "/checkout/result"]);
const FULL_BLEED_ROUTES = new Set(["/", "/login", "/register", "/cart", "/about", "/sell-on-apparify", "/terms-and-conditions", "/privacy-policy"]);

function isCareersRoute(pathname = "") {
  return pathname === "/careers" || pathname.startsWith("/careers/");
}

export function isShopperAccountRoute(pathname = "") {
  return pathname === "/profile/edit" || pathname.startsWith("/account");
}

function isShopperProductListingRoute(pathname = "") {
  return pathname === "/" || pathname === "/products" || pathname.startsWith("/category");
}

function shouldShowCartAction(pathname = "") {
  return !CART_ACTION_HIDDEN_ROUTES.has(pathname);
}

export function getShopperNavbarSearchConfig(pathname = "") {
  if (
    isShopperProductListingRoute(pathname) ||
    pathname.startsWith("/product") ||
    pathname.startsWith("/store") ||
    pathname.startsWith("/cart") ||
    pathname.startsWith("/checkout")
  ) {
    const isListingRoute = isShopperProductListingRoute(pathname);

    return {
      scope: "products",
      searchParam: "search",
      placeholder: "Search products...",
      ariaLabel: "Search products",
      liveSync: isListingRoute,
      submitPath: isListingRoute ? pathname : "/",
      suggestionsEnabled: true,
    };
  }

  return null;
}

function isNavbarSuppressed(pathname) {
  if (NAVBAR_HIDDEN_ROUTES.has(pathname)) return true;
  return NAVBAR_HIDDEN_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}

function isFooterSuppressed(pathname) {
  if (isNavbarSuppressed(pathname)) return true;
  if (FOOTER_HIDDEN_ROUTES.has(pathname)) return true;
  return FOOTER_HIDDEN_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}

export function getShopperLayoutConfig(pathname = "") {
  if (isCareersRoute(pathname)) {
    return {
      showNavbar: false,
      showBottomNav: false,
      showFooter: false,
      fullBleed: true,
      showSearch: false,
      searchConfig: null,
      navbarActions: {},
    };
  }
  const showNavbar = !isNavbarSuppressed(pathname);
  const isAccountRoute = isShopperAccountRoute(pathname);
  const searchConfig = getShopperNavbarSearchConfig(pathname);

  return {
    showNavbar,
    showBottomNav: showNavbar,
    showFooter: !isFooterSuppressed(pathname),
    fullBleed: FULL_BLEED_ROUTES.has(pathname),
    showSearch: showNavbar && Boolean(searchConfig),
    searchConfig,
    navbarActions: {
      showNotifications: showNavbar && !isAccountRoute,
      showProfile: showNavbar && !isAccountRoute,
      showCart: showNavbar && shouldShowCartAction(pathname),
    },
  };
}
